import { Flex } from "antd";
import CancelButton from "../CustomButton/CancelButton";
import PrimaryButton from "../CustomButton/PrimaryButton";
import DangerButton from "../CustomButton/DangerButton";
import CustomButton from "../CustomButton/Button";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import "./CustomForms.scss"
import { BTN_TXT } from "../../constants/constants";

const FormFooter = ({ onCancelClick, noCancel, onSubmitClick, submitLoading, btnName, btnType, disabled, error, rejectBtn, hasPerm = true, draftBtn, onDraftClick, draftLoading }) => {
    return (
        <Flex gap={10} justify="space-between" className="form-footer-container">
            <div>{error && <ErrorAlert error={error} />}</div>
            <Flex gap={10}>
                {draftBtn && (
                    <CustomButton
                        variant="solid"
                        style={{
                            color: "#14286D",
                            backgroundColor: "#F1F5FA",
                            padding: "24px 32px",
                            border: "none",
                            fontSize: 14,
                            borderRadius: 5,
                        }}
                        disabled={draftLoading}
                        loading={draftLoading}
                        onClick={onDraftClick}
                        htmlType="button"
                    >
                        {draftBtn}
                    </CustomButton>
                )}
                {rejectBtn ? (
                    <DangerButton isSolid={true} onClick={onCancelClick}>
                        {BTN_TXT.REJECT}
                    </DangerButton>
                ) : !noCancel ? (
                    <CancelButton
                        onClick={onCancelClick}
                    />
                ) : null}
                {btnType === "danger" ? (
                    <DangerButton isSolid={true} loading={submitLoading} htmlType="submit">
                        {btnName}
                    </DangerButton>
                ) : (btnType === "approve" || btnType === "settle" || btnType === "invoice") ? (
                    hasPerm && (
                        <PrimaryButton loading={submitLoading} onClick={onSubmitClick} disabled={disabled}>
                            {btnName}
                        </PrimaryButton>
                    )
                ) : (
                    <PrimaryButton disabled={disabled} loading={submitLoading} htmlType="submit">
                        {btnName}
                    </PrimaryButton>
                )}
            </Flex>
        </Flex>
    )
}

export default FormFooter